import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actionTypes";
import * as models from "./model";
import CurrentUserApi from "./currentUserApi"; // eslint-disable-line import/no-named-as-default
import { ANONYMOUS_USER } from "./model";

export type CurrentUserAction =
    ({ type: typeof actions.GET_CURRENT_USER_SUCCESS } & Payload<models.CurrentUser>) |
    ({ type: typeof actions.GET_ANONYMOUS_USER_SUCCESS } & Payload<models.CurrentUser>);

export function getCurrentUser() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.GET_CURRENT_USER, CurrentUserApi.get());
        dispatch(getCurrentUserSuccess(result));
    };
}

export const getCurrentUserSuccess = (payload: models.CurrentUser): CurrentUserAction => ({
    payload,
    type: actions.GET_CURRENT_USER_SUCCESS
});

export function getAnonymousUser() {
    return async (dispatch: Dispatch) => {
        const result: models.CurrentUser = {
            authenticated: true,
            name: ANONYMOUS_USER,
            roles: [],
            termsAcceptanceRequired: false,
            canSwitchBetweenPortals: false,
        };
        dispatch(getAnonymousUserSuccess(result));
    };
}

export const getAnonymousUserSuccess = (payload: models.CurrentUser): CurrentUserAction => ({
    payload,
    type: actions.GET_ANONYMOUS_USER_SUCCESS
});

export function updateTermsAccepted() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.UPDATE_TERMS_ACCEPTED, CurrentUserApi.updateTermsAccepted());
        dispatch(getCurrentUserSuccess(result));
    };
}
